export default __webpack_public_path__ + "static/media/contact1.58183aca.jpeg";